import React from 'react';
import HeroSection from '../components/HeroSection/HeroSection';
import { TrustedLogos } from '../components/TrustedLogos/TrustedLogos'; // Changed to named import
import PlatformOverview from '../components/PlatformOverview/PlatformOverview';
import IndustriesGrid from '../components/IndustriesGrid/IndustriesGrid';
import VocabDifference from '../components/VocabDifference/VocabDifference';
import ImpactMetrics from '../components/ImpactMetrics/ImpactMetrics';
import TransformBanner from '../components/TransformBanner/TransformBanner';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <TrustedLogos />
      <PlatformOverview />
      <IndustriesGrid />
      <VocabDifference />
      <ImpactMetrics />
      <TransformBanner />
    </>
  );
};

export default HomePage;
